<script>
import { syncData } from '@/api/config/sync'

export default {
  name: 'SyncData',
  props: {
    url: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      loading: false,
      form: {
        url: ''
      },
      environment: process.env.VUE_APP_ENV
    }
  },
  created() {
    this.form.url = this.$router.resolve(this.$route).href
  },
  methods: {
    onSubmit() {
      if (this.url) {
        this.form.url = this.url
      }
      if (!this.form.url) {
        this.msgError('url获取失败!')
        return
      }
      this.loading = true
      syncData(this.form).then(res => {
        this.loading = false
        this.msgSuccess('同步成功!')
      })
    }
  }
}
</script>

<template>
  <div v-if="environment !== 'production'" style="display: inline-block">
    <el-button style="margin-left: 10px;" type="success" size="mini" :loading="loading" @click="onSubmit">同步线上配置到测试</el-button>
  </div>
</template>

<style scoped>

</style>
